import React from 'react';
import { UiComponent } from 'components';
import { IScheduleItem, SCHEDULE_TYPE_MAP } from 'types';
import { formatDayLabel, formatTimeRange } from './utils';
import * as styles from './style';

interface Props {
  dates: string[];
  selectedDate: string;
  onSelectDate: (date: string) => void;
  items: IScheduleItem[];
  disabled: boolean;
  canMove: (index: number, direction: -1 | 1) => boolean;
  isGrouped: (index: number) => boolean;
  onMove: (index: number, direction: -1 | 1) => void;
  onCreate: () => void;
  onEdit: (item: IScheduleItem) => void;
  onDuplicate: (item: IScheduleItem) => void;
  onDelete: (item: IScheduleItem) => void;
}

function DayTable({
  dates,
  selectedDate,
  onSelectDate,
  items,
  disabled,
  canMove,
  isGrouped,
  onMove,
  onCreate,
  onEdit,
  onDuplicate,
  onDelete,
}: Props) {
  return (
    <UiComponent.Box>
      <div css={styles.boxHead}>
        <UiComponent.BoxTitle title="일차별 일정" />
        <UiComponent.Button
          variant="contained"
          color="black"
          css={{ height: 32, padding: '0 12px' }}
          onClick={onCreate}
          disabled={dates.length === 0}
        >
          + 일정 추가
        </UiComponent.Button>
      </div>

      <div css={styles.tabs}>
        {dates.map((date, index) => (
          <div
            key={date}
            css={styles.tab(date === selectedDate)}
            onClick={() => onSelectDate(date)}
          >
            {formatDayLabel(date, index)}
          </div>
        ))}
      </div>

      <p css={{ marginTop: 12, fontSize: 13 }}>
        총 <b>{items.length}</b>개
      </p>

      <table css={styles.table}>
        <thead>
          <tr>
            <th>시간</th>
            <th>일정명</th>
            <th>한 줄 정보</th>
            <th>유형</th>
            <th>관리</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr>
              <td colSpan={5} css={{ textAlign: 'center', color: '#B2B2B4' }}>
                등록된 일정이 없습니다
              </td>
            </tr>
          )}
          {items.map((item, index) => (
            <tr key={item.id} css={isGrouped(index) && styles.groupedRow}>
              <td css={{ whiteSpace: 'nowrap' }}>{formatTimeRange(item)}</td>
              <td>{item.title}</td>
              <td>{item.summary ?? '-'}</td>
              <td css={{ whiteSpace: 'nowrap' }}>
                {item.type ? SCHEDULE_TYPE_MAP[item.type] : '-'}
              </td>
              <td>
                <div css={styles.manageCell}>
                  {isGrouped(index) && (
                    <>
                      <button
                        type="button"
                        css={styles.orderButton}
                        title="위로"
                        disabled={disabled || !canMove(index, -1)}
                        onClick={() => onMove(index, -1)}
                      >
                        ↑
                      </button>
                      <button
                        type="button"
                        css={styles.orderButton}
                        title="아래로"
                        disabled={disabled || !canMove(index, 1)}
                        onClick={() => onMove(index, 1)}
                      >
                        ↓
                      </button>
                    </>
                  )}
                  <UiComponent.Button
                    variant="border"
                    color="grey"
                    onClick={() => onEdit(item)}
                  >
                    수정
                  </UiComponent.Button>
                  <UiComponent.Button
                    variant="border"
                    color="grey"
                    onClick={() => onDuplicate(item)}
                  >
                    복제
                  </UiComponent.Button>
                  <UiComponent.Button
                    variant="border"
                    color="error"
                    disabled={disabled}
                    onClick={() => onDelete(item)}
                  >
                    삭제
                  </UiComponent.Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </UiComponent.Box>
  );
}

export default DayTable;
